import { Box, Link, useTheme } from '@mui/material'
import { useEffect, useState } from 'react'

export const SkipNavigation = () => {
  const theme = useTheme()
  const [links] = useState([
    { id: 'main-content', label: 'Skip to main content' },
    { id: 'main-navigation', label: 'Skip to navigation' },
    { id: 'footer', label: 'Skip to footer' },
  ])

  useEffect(() => {
    const ensureLandmark = (id: string) => {
      if (!document.getElementById(id)) {
        console.warn(
          `Accessibility: Landmark with id="${id}" not found. Please add it to your layout.`
        )
      }
    }

    links.forEach((link) => {
      ensureLandmark(link.id)
    })
  }, [links])

  const handleSkipClick = (
    event: React.MouseEvent<HTMLAnchorElement>,
    targetId: string
  ) => {
    event.preventDefault()
    const target = document.getElementById(targetId)
    if (target) {
      target.focus()
      target.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  return (
    <Box
      component="nav"
      aria-label="Skip navigation"
      sx={{
        position: 'absolute',
        top: -1000,
        left: -1000,
        width: 1,
        height: 1,
        overflow: 'hidden',
        '&:focus-within': {
          position: 'fixed',
          top: theme.spacing(2),
          left: theme.spacing(2),
          width: 'auto',
          height: 'auto',
          zIndex: 9999,
          overflow: 'visible',
        },
      }}
    >
      {links.map((link) => (
        <Link
          key={link.id}
          href={`#${link.id}`}
          onClick={(e) => handleSkipClick(e, link.id)}
          sx={{
            display: 'block',
            padding: theme.spacing(1, 2),
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            textDecoration: 'none',
            borderRadius: 1,
            mb: 1,
            '&:focus': {
              outline: `3px solid ${theme.palette.secondary.main}`,
              outlineOffset: 2,
            },
          }}
        >
          {link.label}
        </Link>
      ))}
    </Box>
  )
}
